import { isMiniFeatureEnabled } from 'owa-mini-feature-flags';
import { isNonPrivateCloud } from 'mini-common-utils/lib/utils/isNonPrivateCloud';

export const isDisplayViewEnabled = () => {
    return isNonPrivateCloud() && isMiniFeatureEnabled('mini-options-display-view');
};
